
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'TomlCodeViewer',
  props: {
    toml: {
      type: String,
      required: true
    },
    syntaxHighlighting: {
      type: Boolean,
      default: true
    }
  }
})
